import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { 
    Firestore, 
    doc,
    docData,
    DocumentData, 
    collection,
    collectionData,
} from '@angular/fire/firestore';
import { ActivatedRoute, NavigationExtras } from "@angular/router";
import {
	IonContent,
	MenuController,
	ToastController,
	Platform,
	NavController
} from "@ionic/angular";
import { Events } from 'src/app/shared/services/global/events.service';
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { DateTime } from "luxon";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { TypeTracking } from "src/app/enums/type-tracking";
import { CeuGroup } from "src/app/models/ceu-group";
import { CeuTrack } from "src/app/models/ceu-track";
import { DateService } from "src/app/providers/date/date.service";
import { DaoScheduleService } from "src/app/providers/db/dao-schedule.service";
import { DaoSessionFeedbackService } from "src/app/providers/db/dao-session-feedback.service";
import { DaoTrackService } from "src/app/providers/db/dao-tracks.service";
import { LuxonService } from "src/app/providers/luxon/luxon.service";
import { GetScheduleSessions } from "src/app/shared/actions/schedules.actions";
import { AppState } from "src/app/shared/reducers";
import { AnalyticsService, GlobalService } from "src/app/shared/services";
import { TypeVisionModule } from "../../models/type-vision-module";
import { DaoGroupsService } from "../../providers/db/dao-groups.service";
import { PathApi } from "./../../paths/path-api";
import { DateTimeService } from "src/app/providers/date-time/date-time.service";
import { EventColors } from "src/app/models/event-colors";
import { UserDataService } from "src/app/shared/services/user-data/user-data.service";
import { EventDataService } from "src/app/shared/services/eventData/event-data.service";

@Component({
	selector: "app-schedule",
	templateUrl: "./schedule.page.html",
	styleUrls: ["./schedule.page.scss"]
})
export class SchedulePage implements OnInit, OnDestroy {
	subscriptions: Subscription[] = [];
	public module = null;

	isMobile: boolean = false;

	// @ViewChild(IonInfiniteScroll)
	// infiniteScroll: IonInfiniteScroll;
	// @ViewChild(IonVirtualScroll)
	// virtualScroll: IonVirtualScroll;
	@ViewChild("content") content: IonContent;
	@ViewChild('datePillStrip', { read: ElementRef, static: false }) datePillStrip: ElementRef;

	eventId: string = null;
	moduleId: string = null;
	sessionFeedbackModule: string = null;

	//https options
	public requestOptions: any;
	public headers: any;

	lastSession = null;

	loader: boolean;
	loaderByTrack: boolean = false;

	habilitedLimit: boolean = false;

	selectedDate = "all";
	sessions: any[] = [];
	sessionsAll: any[] = [];
	dates: Array<string> = [];
	allSessionDates: any[] = [];
	tracks: Array<CeuTrack> = [];
	selectedTrackId = null;
	locations: Array<any> = [];

	groups = [];
	userGroups: any = [];

	viewHour: boolean = false;
	viewTrack: boolean = false;
	viewGroup: boolean = false;

	backBtn: boolean = true;

	searchBtn: boolean = true;
	searchOpen: boolean = false;

	eventColors: EventColors = new EventColors();
	menuBadge: number = 0;

	typeVisionModule = null;
	GLOBAL_VISION = TypeVisionModule.GLOBAL_VISION;
	DIVIDED_BY_GROUPS = TypeVisionModule.DIVIDED_BY_GROUPS;
	GROUP_VISION = TypeVisionModule.GROUP_VISION;
	GROUP_ACCESS_PERMISSION = TypeVisionModule.GROUP_ACCESS_PERMISSION;

    language: string;

	allowCloseReferences: boolean = true;

	sessionIndex: number = -1;

	showHeader: boolean;
	showSpeakers: boolean;
	showDescription: boolean;
	showCustomFields: boolean;
	icsDownloadable: boolean;

	customFields: any[] = [];
	eventFormatedLang: any;
	arraryCustoms: any[][] = [];
	customs: any;

	filterButton: boolean = true;
	sessionsByTracks: any[] = [];

	filteredSessions: Array<any> = [];
	selectedTrackIds: string[] = [];
	selectedLocationNames: string[] = [];
	hideSoldOut: boolean = false;
	filterDates: string;

	currentTime: number = Date.now();
	private liveTimer: any;

	showFilterSheet: boolean = false;

	get activeFilterCount(): number {
		return this.selectedTrackIds.length + this.selectedLocationNames.length + (this.hideSoldOut ? 1 : 0);
	}

    moduleBehavior: string;
    userId: string;

	constructor(
		private route: ActivatedRoute,
		private luxon: LuxonService,
		public http: HttpClient,
		public global: GlobalService,
		private dbSchedule: DaoScheduleService,
		public toastController: ToastController,
		private navCtrl: NavController,
		private events: Events,
		private menuCtrl: MenuController,
		private translateService: TranslateService,
		private SAnalytics: AnalyticsService,
		private dbTracks: DaoTrackService,
		private dbGroups: DaoGroupsService,
		private daoFeedback: DaoSessionFeedbackService,
		private store: Store<AppState>,
		private SDate: DateService,
		private firestore: Firestore,
        private dt: DateTimeService,
        private SUserData: UserDataService,
        private SEventData: EventDataService,
				private platform: Platform,
	) {
		this.headers = new HttpHeaders();
		this.headers.append("Accept", "application/json");
		this.headers.append("Content-Type", "application/json");
		this.requestOptions = { headers: this.headers };

		//this.menuCtrl.enable(true);

		this.events.subscribe("menuBadge", () => {
			this.menuBadge = this.global.notificationBadge;
		});
	}

	loadModuleFeedback() {
		this.daoFeedback.getFeedbackModule(this.eventId, (modules) => {
			if (modules.length >= 1) {
				this.sessionFeedbackModule = modules[0].uid;
			}
		});
	}

    /**
     * @description get event colors
     * @param eventId 
     */
    loadColors(eventId: string = this.eventId) {
        const sub = this.SEventData.getEventDataListener(eventId).subscribe((eventData) => {
            this.eventColors = eventData.colors;

            const el = document.getElementById("header-agenda");
            if (el !== undefined && el !== null) el.style.setProperty("--box-shadow-color", this.eventColors.link_color + "40");

            document.body.style.setProperty('--menu-color', this.eventColors.menu_color);
            document.body.style.setProperty('--menu-text-color', this.eventColors.menu_text_color);
        });
        this.subscriptions.push(sub);
    }

	scheduleTrackName: string = this.translateService.instant("pages.schedule.filter_track");

	ngOnInit() {
        this.moduleBehavior = this.route.snapshot.parent.url[0].path;   // as schedule or personal-schedule

		if (this.platform.is('mobile')) this.isMobile = true;

        const params = this.route.snapshot.params;
        this.eventId = params.eventId;
        this.moduleId = params.moduleId;

        this.loadColors();
        this.language = this.SEventData.getLanguage();
        this.menuBadge = this.global.notificationBadge;
        this.loadModuleFeedback();

        // Track analytics
        this.SAnalytics.moduleAccess(this.eventId, this.moduleId);

        if (this.moduleBehavior == "schedule") {
            this.SAnalytics.createTrackRoadToModule(
                this.eventId,
                this.moduleId,
                TypeTracking.ACCESS_TO_SCHEDULES_MODULE
            );
            this.getLocations();
            this.getTracksModule();
        }

        this.loaderByTrack = false;

        // if (this.global.previousPage == "container")
        //     this.backBtn = false;
        // else
        //     this.backBtn = true;

        this.getModuleSettings();
        this.getSessionsData(this.typeVisionModule);

        this.liveTimer = setInterval(() => {
            this.currentTime = Date.now();
        }, 30000);
	}

	ionViewWillEnter() {
		if (this.sessions.length > 0) {
			//this.virtualScroll.checkEnd();
			if (this.sessionsAll.length == 1) {
				this.openSession(this.sessionsAll[0].uid);
			}
		}
	}

	headerHeightFn(item, index) {
		return 30;
	}

	itemHeightFn(item, index) {
		if (item.tracks.length > 0) return 118;
		if (item.locations.length === 0) return 61;
		return 75;
	}

    /**
     * @description fetch the schedule data (from module schedule or personal-schedule), and 
     * assign some of its contentsd to properties, responsible for the behavior of this component 
     */
	getModuleSettings(): void {
		//this.sessions = [];
		// this.sessionsAll = [];
		// this.selectedDate = "all";
		// this.selectedTrackId = null;

		// get the module information
		this.subscriptions.push(
			this.dbSchedule.getModule(this.eventId, this.moduleId).subscribe(async (module) => {
				this.module = module;

                this.showHeader = (module.showHeader !== undefined) ? module.showHeader : true;
                this.showSpeakers = (module.showSpeakers !== undefined) ? module.showSpeakers : false;
                this.showDescription = (module.showDescription !== undefined) ? module.showDescription : false;
                this.showCustomFields = (module.showCustomFields !== undefined) ? module.showCustomFields : false;
                this.icsDownloadable = (module.icsDownloadable !== undefined) ? module.icsDownloadable : false;
                this.filterButton = (module.enableTrackFilter !== undefined) ? module.enableTrackFilter : false;

                const el = document.getElementById(`${this.moduleId}-filtring-header`);
                if (el !== undefined && el !== null) el.style.display = this.showHeader ? "block" : "none";

                this.typeVisionModule = module.typeVision;
                if (module.trackName) { this.scheduleTrackName = module.trackName[this.language]; }
                this.habilitedLimit = module.habilitedLimit;

				// // verifies the type of vision of the module. global vision
				// if (this.typeVisionModule === this.GLOBAL_VISION) {
				// 	// this.getGlobalVision();
				// }

				// //divided by groups
				// if (this.typeVisionModule === this.DIVIDED_BY_GROUPS) {
				// 	this.getDividedByGroupsVision();
				// }

				// // group vision
				// if (this.typeVisionModule === this.GROUP_VISION) {
				// 	this.getGroupVision();
				// }

				// //limited access by groups
				// if (this.typeVisionModule === this.GROUP_ACCESS_PERMISSION) {
				// 	this.getLimitedAccessByGroupsVision();
				// }
			})
		);
	}

	ionViewWillLeave() {}

	/**
	 * Unsubscribe all subscriptions
	 */
	ngOnDestroy() {
		this.selectedDate = "all";
		this.selectedTrackId = null;
		this.viewHour = false;
		this.viewTrack = false;
		this.viewGroup = false;

		this.searchBtn = false;
		this.searchOpen = false;

		this.groups = [];
		this.tracks = [];
		this.sessions = [];
		this.sessionsAll = [];

		clearInterval(this.liveTimer);

		// close refs
		this.dbSchedule.closeRefGetNextPageSessionsGlobalVision();
		this.dbSchedule.closeRefGetSessionsGroupGlobalVision();
		this.dbSchedule.closeRefGetSessionsGroupsVision();
		this.dbSchedule.closeRefGetNextPageSessionsLimitedAccessByGroups();

		this.dbGroups.closeRefGetGroups();
		this.dbGroups.closeRefContSessionsOfGroup();

		this.dbTracks.closeGetTracksModule();
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	// /**
	//  * Reload date for sessions
	//  */
	// reloadDateForSessions() {
	// 	this.virtualScroll.checkEnd();
	// }

	/**
	 * Puts the session date in front
	 * @param session
	 * @param index
	 * @param sessionsList
	 */
	dateHeader(session, index, sessionsList) {
		if (index == 0 || (index != 0 && session.date != sessionsList[index - 1].date)) {
			return session.dateFormated;
		}
	}

	// clear the session fields for front view
	setTheSession(session) {
		// dates
		// if (typeof session.date === "number") {
		// 	if (this.SEventData.eventData.language && this.SEventData.eventData.language == "en_US") {
		// 		if (session.newDate) {
		// 			// let day = (session.newDate.day.toString().length == 1) ? '0' + session.newDate.day.toString() : session.newDate.day.toString();
		// 			// let month = (session.newDate.month.toString().length == 1) ? '0' + session.newDate.month.toString() : session.newDate.month.toString();
		// 			// let year = (session.newDate.year.toString().length == 1) ? '0' + session.newDate.year.toString() : session.newDate.year.toString();
		// 			// session.dateFormated = month + '/' + day + '/' + year;
		// 			session.dateFormated = this.luxon.getStringDateFromDate(session.newDate, 0);
		// 		} else {
		// 			session.dateFormated = moment.unix(session.date).format("MM/DD/YYYY");
		// 		}
		// 	} else {
		// 		if (session.newDate) {
		// 			// let day = (session.newDate.day.toString().length == 1) ? '0' + session.newDate.day.toString() : session.newDate.day.toString();
		// 			// let month = (session.newDate.month.toString().length == 1) ? '0' + session.newDate.month.toString() : session.newDate.month.toString();
		// 			// let year = (session.newDate.year.toString().length == 1) ? '0' + session.newDate.year.toString() : session.newDate.year.toString();
		// 			// session.dateFormated = day + '/' + month + '/' + year;
		// 			session.dateFormated = this.luxon.getStringDateFromDate(session.newDate, 1);
		// 		} else {
		// 			session.dateFormated = moment.unix(session.date).format("DD/MM/YYYY");
		// 		}
		// 	}
		// }

        // start and end time
        // session.startTime = this.dt.getConvertedTime(session.startTime, this.module.timezoneType);
		// session.endTime = (typeof session.endTime == "string" || session.endTime.length > 0) ?
		// 	this.dt.getConvertedTime(session.endTime, this.module.timezoneType) :
		// 	"--:--";

        const timezone = (this.moduleBehavior == "schedule") ? this.module.timezoneType : "event";
        session.startTime = this.hasValidTime(session.startTime) ? this.dt.getConvertedTime(session.startTime, timezone) : null;
        session.endTime = this.hasValidTime(session.endTime) ? this.dt.getConvertedTime(session.endTime, timezone) : null;

		// locations of session
		const locations = [];

		for (const uid in session.locations) {
			locations.push(session.locations[uid]);
		}

		// sort by the order field.
		locations.sort(function (a, b) {
			return a.order - b.order;
		});

		session.locations = locations;

		// tracks of session
		const tracks = [];

		for (const uid in session.tracks) {
			tracks.push(session.tracks[uid]);
		}

		tracks.sort((a, b) => (a.identifier < b.identifier ? -1 : a.identifier > b.identifier ? 1 : 0));

		session.tracks = tracks;

		// groups of session
		const groups = [];

		for (const uid in session.groups) {
			groups.push(session.groups[uid]);
		}

		session.groups = groups;

		// -------- Custom fields ------- //
		let attendeeCustomFields: any[] = [];

		// tslint:disable-next-line: forin
		for (const uid in session.customFields) {
			attendeeCustomFields.push(session.customFields[uid]);
		}

		if (this.customs) {
			let arrayTemp = [];
			this.customs.forEach((e) => {
				if (
					attendeeCustomFields.some(
						(a) =>
							a.uid === e.uid &&
							e.textValue[this.eventFormatedLang] &&
							e.textValue[this.eventFormatedLang].length > 0
					)
				) {
					this.customFields.push(e);
					arrayTemp.push(e);
				}
			});
			this.arraryCustoms.push(arrayTemp);
		}

		return session;
	}

	async gettingAttendeeCustomFields(): Promise<any> {
		let userId = this.SUserData.userId;
		// userId = await this.global.loadUserId();

		if (userId) {
			return new Promise((res, rej) => {
                const ref = doc(this.firestore, `events/${this.eventId}/attendees/${this.SUserData.userId}`);
                docData(ref).pipe(take(1)).subscribe((attendee) => {
					// this.customFields = [];
					if (attendee) {
						const customs = attendee.customFields;
						if (customs && customs.length > 0) {
							res(customs);
						} else {
							rej("No custom fields for the actual attendee !");
						}
					}
				});
			});
		} else {
			return Promise.reject("No custom fields for the actual attendee !");
		}

		// this.arraryCustoms = [[]]
	}

	// loads the module tracks.
	allowFilterTracks: boolean = false;
	getTracksModule() {
		this.dbTracks.getTracksModule(this.moduleId, this.language, (data) => {
			if (data.length >= 1) {
				this.allowFilterTracks = true;
			} else {
				this.allowFilterTracks = false;
			}
			this.tracks = [];
			this.tracks = data;
		});
	}

	async presentToast(time) {
		const toast = await this.toastController.create({
			message: time,
			duration: 3000
		});

		toast.present();
	}

	// filter sessions by name
	filterSessionsByName(ev) {
		const letters = ev.target.value;
		this.lastSession = null;

		if (letters.trim().length === 0) {
			this.sessions = [...this.sessionsAll];
		} else {
			this.sessions = this.sessionsAll.filter((s) =>
				s.name[this.language].toLowerCase().includes(letters.toLowerCase())
			);
		}

		this.filterSessions();
	}

	// // filter session by date
	 activeDate: string = "all";
	// filterByDate(date: string) {
	// 	this.sessions = [];
	// 	this.loader = true;
	// 	this.loaderByTrack = true;
	// 	this.lastSession = null;
	// 	this.selectedDate = date;
	// 	this.activeDate = date;

	// 	// Filter by dates
	// 	if (this.selectedDate == "all") {
	// 		this.sessions = [...this.sessionsAll];
	// 	} else {
	// 		if (!this.filterByTrackSpecial) {
	// 			for (const session of this.sessionsAll) {
	// 				let sessionDate = session.newDate.day + "/" + session.newDate.month + "/" + session.newDate.year;
	// 				if (date === sessionDate) {
	// 					this.sessions.push(session);
	// 				}
	// 			}
	// 		} else {
	// 			for (const session of this.sessionsAll) {
	// 				let sessionDate = session.newDate.day + "/" + session.newDate.month + "/" + session.newDate.year;

	// 				if (date === sessionDate) {
	// 					this.sessions.push(session);
	// 				}
	// 			}

	// 			this.filterByTrackSpecialOperation();
	// 		}
	// 		this.allSessionDates = Array.from(new Set([...this.sessionsAll].map((item) => item.dateFormated)));
	// 	}

	// 	this.scrollToTop();
	// 	this.loader = false;
	// 	this.loaderByTrack = false;
	// }

	// filter session by track
	// filterByTrack($ev) {
	// 	this.sessions = [];
	// 	this.loaderByTrack = true;
	// 	this.loader = false;
	// 	this.lastSession = null;
	// 	this.selectedDate = "all";

	// 	if ($ev.target.value === "all") {
	// 		this.sessions = this.sessionsAll;
    //         this.selectedTrackId = null;
    //         this.viewTrack = false;
	// 	} else {
	// 		let track = $ev.target.value;
	// 		this.selectedTrackId = track.uid;

	// 		// filter the sessions by track
	// 		for (const session of this.sessionsAll) {
	// 			const index = session.tracks.map(e => e.uid).indexOf(this.selectedTrackId);

	// 			if (index > -1) {
	// 				this.sessions.push(session);
	// 			}
	// 		}
    //         this.viewTrack = true;
	// 	}
	// 	this.allSessionDates = Array.from(new Set([...this.sessions].map((item) => item.dateFormated)));
	// 	this.loaderByTrack = false;
	// }


    /**
	 * @description Apply filters to the list of sessions presented in the schedule module
	 */
	async filterSessions() {
		this.filteredSessions = (await this.filterGroupAccess(this.sessions));

		// by date
		this.filteredSessions = this.filteredSessions.filter((session) => {
			return (session.date == this.filterDates);
		});

		// by tracks (multi-select)
		if (this.selectedTrackIds.length > 0) {
			this.filteredSessions = this.filteredSessions.filter((session) => {
				for (let track of session.tracks) {
					if (this.selectedTrackIds.includes(track.identifier)) {
						return true;
					}
				}
				return false;
			});
		}

		// by locations (multi-select)
		if (this.selectedLocationNames.length > 0) {
			this.filteredSessions = this.filteredSessions.filter((session) => {
				for (let location of session.locations) {
					if (location.name && this.selectedLocationNames.includes(location.name)) {
						return true;
					}
				}
				return false;
			});
		}

		// hide sold out sessions
		if (this.hideSoldOut) {
			this.filteredSessions = this.filteredSessions.filter((session) => {
				return !(this.habilitedLimit && session.limitAttendees > 0 && session.qtdAttendees >= session.limitAttendees);
			});
		}

		this.loader = false;
		this.scrollToTop();
	}

	/**
	 * @description filter sessions by group (i.e. check if the user has group access to the sessions)
	 * @param sessions 
	 * @returns the sessions available to the user
	 */
	async filterGroupAccess(sessions: any[]) {
        const groups: Object = (await this.SUserData.getUserDataSnapshot()).groups
		const groupIds: Array<string> = (groups) ? Object.keys(groups) : [];

		let auxDate: string = "";
		let filteredSessions = sessions.filter((session) => {
			let sessionGroupIds: Array<string> = [];
			if (session.groups) {
				session.groups.forEach((group) => {
					sessionGroupIds.push(group.uid)
				});
			}
			else { return true; }

			// if session isnt restricted by groups 
			if (sessionGroupIds.length == 0) { return true; }

			// check if the any of the user groups match with any of the session groups
			for (let i = 0; i < groupIds.length; i++) {
				if (sessionGroupIds.includes(groupIds[i])) {
					return true;
				}
			}

			auxDate = session.date;
			return false;
		});

		if (auxDate != "" && !filteredSessions.some((session) => session.date == auxDate)) {
			const index = this.dates.indexOf(auxDate);
			if (index > -1) this.dates.splice(index, 1);
		}

		return filteredSessions;
	}

	filterByDate(date: string) {
		this.filterDates = date;
		this.filterSessions();
	}
	
	openFilterSheet(): void {
		this.showFilterSheet = true;
	}

	toggleSheetTrack(trackId: string): void {
		const idx = this.selectedTrackIds.indexOf(trackId);
		if (idx > -1) {
			this.selectedTrackIds.splice(idx, 1);
		} else {
			this.selectedTrackIds.push(trackId);
		}
		this.filterSessions();
	}

	toggleSheetLocation(location: string): void {
		const idx = this.selectedLocationNames.indexOf(location);
		if (idx > -1) {
			this.selectedLocationNames.splice(idx, 1);
		} else {
			this.selectedLocationNames.push(location);
		}
		this.filterSessions();
	}

	toggleHideSoldOut(): void {
		this.hideSoldOut = !this.hideSoldOut;
		this.filterSessions();
	}

	clearAllFilters(): void {
		this.selectedTrackIds = [];
		this.selectedLocationNames = [];
		this.hideSoldOut = false;
		this.showFilterSheet = false;
		this.searchOpen = false;
		this.sessions = [...this.sessionsAll];
		this.filterSessions();
	}

	/**
	 * @description get schedule sessions of the current module
	 */
	async getSessionsData(typeVisio?: number) {
        /**
         * @description callback responsible to handle the data of sessions 
         */
        const handleSessionData = (sessions: Array<DocumentData>) => {
            this.sessions = sessions.map((sess) => this.setTheSession(sess));
            this.sessionsAll = [...this.sessions];
            this.activeDate = 'all';

            this.dates = [];
			sessions.forEach((session) => {
				session.date = (typeof session.date == "string") ? 
                    `${session.date.substring(0, 11)}00:00:00.000` : session.date;
                
				if (!this.dates.includes(session.date))
					this.dates.push(session.date);
			});

            this.filterDates = this.dates[0];
            this.filterSessions();
            this.loadSessionAttendeeCounts();
        }

        if (this.moduleBehavior == "personal-schedule")
            this.subscriptions.push(
                this.dbSchedule
                    .getPersonalSchedule(this.eventId, this.SUserData.userId)
                    .subscribe(handleSessionData)
            )
        else
            this.subscriptions.push(
                this.dbSchedule.getSess(this.moduleId)
                    .subscribe(handleSessionData)
            )
	}

    /**
     * @description fetch attendee count for sessions with limitAttendees > 0
     */
    loadSessionAttendeeCounts() {
        if (!this.habilitedLimit) return;

        this.sessions.forEach((session) => {
            if (session.limitAttendees && session.limitAttendees > 0) {
                const ref = collection(this.firestore, `modules/${this.moduleId}/sessions/${session.uid}/attendees`);
                const sub = collectionData(ref).subscribe((attendees) => {
                    session.qtdAttendees = attendees.length;
                });
                this.subscriptions.push(sub);
            }
        });
    }

    /**
     * @description make a request to the firestore db to retrive all locations related to this 
     * event, then allocate them in the array "locations".
     */
    getLocations(): void {
        this.dbSchedule.getLocations(this.eventId).then((locations) => {
            locations.forEach((location) => {
                this.locations.push(location.identifier);
            });
        }).catch((error) => {
            console.log(error);
        })
    }


	// activates and deactivates boolean variables that control the html tab, the part of filters by date and by tracks
	changeView($ev) {
		this.selectedDate = null;
		this.selectedTrackId = null;

		switch ($ev.detail.value) {
			case "byHour":
				this.viewTrack = false;
				this.viewHour = true;
				this.selectedDate = "all";
				this.sessions = this.sessionsAll;
				this.allSessionDates = Array.from(new Set([...this.sessions].map((item) => item.dateFormated)));

				break;
			case "byTracks":
				this.viewHour = false;
				this.viewTrack = true;
				break;
		}
	}

	openSession(sessionId) {
		const session = this.sessions.find((s) => s.uid == sessionId);
		const moduleScheduleId = session?.moduleId || this.moduleId;
		this.sessionIndex = this.sessions.indexOf(session);
		this.allowCloseReferences = false;
		let navigationExtras: NavigationExtras = {
			state: {
				sessionFeedbackModule: this.sessionFeedbackModule
			}
		};

		this.navCtrl.navigateForward(
			`/event/${this.eventId}/schedule-detail/${moduleScheduleId}/${sessionId}`,
			navigationExtras
		);
	}

	// // loads more sessions when the infinite scroll is triggered
	// moreSessions(event) {
	// 	// verifies the type of vision of the module.
	// 	if (this.typeVisionModule === this.GLOBAL_VISION) {
	// 		this.moreSessionsGlobalVision(event);
	// 	} else if (this.typeVisionModule === this.GROUP_ACCESS_PERMISSION) {
	// 		this.moreSessionsLimitedAccessByGroups(event);
	// 	} else {
	// 		event.target.disabled = true;
	// 	}
	// }

	/******************************************************************************** methods of global vision *************************************************************************************** */

	allSessionsLength: number = 0; //get number of sessions you have in module
	allowFilterByDate: boolean = false; //controls the date filter

	getHumanDate(date: string) {
		return DateTime.fromISO(date).toFormat("HH:mm");
	}

	// load the global view
	// async getGlobalVision() {
	// 	this.loader = true;

	// 	this.viewHour = true;
	// 	this.viewTrack = false;
	// 	this.viewGroup = false;

	// 	this.searchBtn = true;

	// 	this.customs = await this.gettingAttendeeCustomFields().catch((e) => console.log(e));

	// 	// loads the first 100 sessions of the module.
 	// 	this.dbSchedule.getFirstPageSessionsGlobalVision(this.moduleId).subscribe((data) => {
	// 		let nextPage = null;
	// 		let list = [];

	// 		if (data) {
	// 			nextPage = data["nextPage"];
	// 			list = [...data["sessions"]];
	// 		}

	// 		// takes the start time of the last session loaded.
	// 		if (nextPage) {
	// 			this.lastSession = nextPage;
	// 		}

	// 		// treatment of sessions
	// 		for (let session of list) {
	// 			session = this.setTheSession(session);
	// 		}

	// 		this.sessions = list;
	// 		if (this.filterByTrackSpecial) {
	// 			this.sessionsByTracks = [];
	// 			list.forEach((session) => {
	// 				if (session.tracks.length > 0) {
	// 					session.tracks.forEach((track) => {
	// 						let groupTrack = this.sessionsByTracks.find(
	// 							(group) => group.track && group.track.uid === track.uid
	// 						);
	// 						if (!groupTrack) {
	// 							this.sessionsByTracks.push({
	// 								beginDate: "",
	// 								endDate: "",
	// 								mainLocation: null,
	// 								sessions: [session],
	// 								track: track
	// 							});
	// 						} else {
	// 							groupTrack.sessions.push(session);
	// 						}
	// 					});
	// 				} else {
	// 					this.sessionsByTracks.push({
	// 						beginDate: DateTime.fromObject(session.newStartTime).toISO(),
	// 						endDate: session.newEndTime ? DateTime.fromObject(session.newEndTime).toISO() : null,
	// 						mainLocation: null,
	// 						sessions: [session],
	// 						track: null
	// 					});
	// 				}
	// 			});
	// 			this.sessionsByTracks
	// 				.map((groupTrack) => {
	// 					groupTrack.sessions.sort((a, b) =>
	// 						DateTime.fromObject(a.newStartTime) > DateTime.fromObject(b.newStartTime)
	// 							? 1
	// 							: DateTime.fromObject(a.newStartTime) < DateTime.fromObject(b.newStartTime)
	// 							? -1
	// 							: 0
	// 					);
	// 					groupTrack.beginDate =
	// 						groupTrack.sessions.length > 0
	// 							? DateTime.fromObject(groupTrack.sessions[0].newStartTime).toISO()
	// 							: "";
	// 					groupTrack.endDate =
	// 						groupTrack.sessions.length > 0 &&
	// 						groupTrack.sessions[groupTrack.sessions.length - 1].newEndTime
	// 							? DateTime.fromObject(
	// 									groupTrack.sessions[groupTrack.sessions.length - 1].newEndTime
	// 							  ).toISO()
	// 							: "";
	// 					let locations = [];
	// 					groupTrack.sessions.forEach((session) => {
	// 						if (session.locations.length > 0) {
	// 							session.locations.forEach((location) => {
	// 								if (!locations.find((loc) => loc.uid === location.uid)) {
	// 									locations.push(location);
	// 								}
	// 							});
	// 						}
	// 					});

	// 					if (locations.length === 1) {
	// 						groupTrack.mainLocation = locations[0];
	// 					}

	// 					return groupTrack;
	// 				})
	// 				.sort((a, b) => (a.beginDate > b.beginDate ? 1 : a.beginDate < b.beginDate ? -1 : 0));
	// 		}

	// 		this.allSessionDates = Array.from(new Set([...this.sessions].map((item) => item.dateFormated)));
	// 		// this.loadAllSessionsAndDates();
	// 		this.loader = false;
	// 	});

	// 	// counts the total sessions you have in the module. (global vision)
	// 	this.dbSchedule.countsSessionsInTheModule(this.moduleId, (total) => {
	// 		this.allSessionsLength = total;
	// 	});

	// 	// load all module sessions and all different dates. Using the api
	// 	this.dbSchedule.getAllSessionsVisionGlobal(this.moduleId).subscribe((sessions) => {
	// 		this.sessionsAll = [];
	// 		this.dates = [];

	// 		[...sessions].forEach((session) => {
	// 			this.sessionsAll.push(this.setTheSession(session));
	// 			// pick up all different dates of sessions
	// 			const index = this.dates.indexOf(session.date.toString());

	// 			if (index === -1) {
	// 				this.dates.push(session.newDate);
	// 			}
	// 		});
	// 		this.dates = [...this.dates].filter(
	// 			(date, index, self) =>
	// 				index ===
	// 				self.findIndex(
	// 					(x) =>
	// 						x.day === date.day &&
	// 						x.hour === date.hour &&
	// 						x.millisecond === date.millisecond &&
	// 						x.minute === date.minute &&
	// 						x.month === date.month &&
	// 						x.second === date.second &&
	// 						x.year === date.year &&
	// 						x.zone === date.zone
	// 				)
	// 		);
	// 		// Push sessions on store
	// 		this.pushScheduleSessionsOnStore(this.sessionsAll);
	// 		if (this.dates) this.allowFilterByDate = true;
	// 	});
	// }

	//this.http.post(PathApi.authChangeUserType, email, this.requestOptions)
	//             .subscribe(_ => {
	//                 // case exists, return 'exists' to front manipulation
	//                 resolve('exists');
	//             }, e => {
	//                 // case not exists, return 'available' to front manipulation
	//                 reject('available');
	//             });
	generateIcsFile(session) {
		this.loader = true;
		if (session) {
			return new Promise((resolve, reject) => {
				//decalage en heures
				const testDate = new Date();
				let offsetHours = testDate.getTimezoneOffset() / 60;
				this.http
					.post(
						PathApi.dbScheduleGenerateIcsFile,
						{
							moduleId: this.moduleId,
							eventId: this.eventId,
							sessionId: session.uid,
							eventLanguage: this.SEventData.getLanguage(),
							offsetHours: offsetHours
						},
						this.requestOptions
					)
					.subscribe(
						(res) => {
							if (res && res["message"] === "success") {
								const sessionNameWithExtension = session.name[this.eventFormatedLang] + ".ics";

								let sessionName = sessionNameWithExtension.toLowerCase();
								sessionName = sessionName.split(/[ ,]+/).join("_");
								sessionName = sessionName.split(/[ ']+/).join("");
								this.downloadFile(sessionName, res["result"]);
								resolve(res);
								this.loader = false;
							}
						},
						(err) => {
							reject(err);
						}
					);
			});
		}
	}

	linkEventToGoogleCalendar(session) {
		this.loader = true;
		if (session) {
			const googleLinkPrefix = "https://calendar.google.com/calendar/render?action=TEMPLATE&";
			return new Promise((resolve, reject) => {
				//decalage en heures
				const testDate = new Date();
				let offsetHours = testDate.getTimezoneOffset() / 60;
				this.http
					.post(
						PathApi.dbScheduleGenerateIcsFile,
						{
							moduleId: this.moduleId,
							eventId: this.eventId,
							sessionId: session.uid,
							eventLanguage: this.SEventData.getLanguage(),
							offsetHours: offsetHours
						},
						this.requestOptions
					)
					.subscribe(
						(res) => {
							if (res && res["message"] === "success") {
								const icsData: string = res["result"];
								// formating data for the link
								let splitedData = icsData.split("\n");
								splitedData = splitedData.map((s) => s.replace("\r", ""));
								const arrayTimestamp = splitedData.filter((s) => s.startsWith("DTSTAMP"));
								const timestamp = arrayTimestamp[0].split(":")[1];
								const arrayTimestampStart = splitedData.filter((s) => s.startsWith("DTSTART"));
								const timestampStart = arrayTimestampStart[0].split(":")[1];
								const arrayTimestampEnd = splitedData.filter((s) => s.startsWith("DTEND"));
								const timestampEnd = arrayTimestampEnd[0].split(":")[1];

								const sessionNameEncoded =
									session.name[this.eventFormatedLang] !== undefined
										? encodeURI(session.name[this.eventFormatedLang])
										: "";

								const sessionDescriptionEncoded =
									session.descriptions && session.descriptions[this.eventFormatedLang] != undefined
										? encodeURI(session.descriptions[this.eventFormatedLang])
										: "";

								const datesEncoded = encodeURI(timestampStart + "/" + timestampEnd);

								const link =
									googleLinkPrefix +
									"dates=" +
									datesEncoded +
									"&text=" +
									sessionNameEncoded +
									"&details=" +
									sessionDescriptionEncoded;

								let a = document.createElement("a");
								a.setAttribute("href", link);
								a.setAttribute("target", "blank");
								a.click();
								resolve(res);
								this.loader = false;
							}
						},
						(err) => {
							reject(err);
						}
					);
			});
		}
	}

	downloadAgenda() {
		this.loader = true;
		return new Promise((resolve, reject) => {
			// Decalage en heures
			const testDate = new Date();
			let offsetHours = testDate.getTimezoneOffset() / 60;
			this.http
				.post(
					PathApi.dbScheduleGenerateAllIcs,
					{
						moduleId: this.moduleId,
						eventId: this.eventId,
						eventLanguage: this.SEventData.getLanguage(),
						offsetHours: offsetHours
					},
					this.requestOptions
				)
				.subscribe(
					(res) => {
						if (res && res["message"] === "success") {
							this.downloadFile("Agenda.ics", res["result"]);
							resolve(res);
							this.loader = false;
						}
					},
					(err) => {
						reject(err);
					}
				);
		});
	}

	downloadFile = (filename: string, text) => {
		const element = document.createElement("a");
		element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
		element.setAttribute("download", filename);
		element.setAttribute("target", "_blank");
		element.style.display = "none";
		element.click();
	};

	// loads more sessions when the infinite scroll is triggered (global vision)
	moreSessionsGlobalVision(event) {
		if (this.sessions.length < this.sessionsAll.length) {
			if (this.lastSession) {
				// convert a date plus the start time of the last session to timastamp for the search of the bank.
				let year = "2019";
				let month = "12";
				let day = "01";
				let hour = "00";
				let minute = "00";
				let seconds = "00";

				// const array1 = this.lastSession.date.split("/");
				// day = array1[0];
				// month = array1[1];
				// year = array1[2];

				day =
					this.lastSession.newDate.day < 10
						? `0${this.lastSession.newDate.day}`
						: this.lastSession.newDate.day;
				month =
					this.lastSession.newDate.month < 10
						? `0${this.lastSession.newDate.month}`
						: this.lastSession.newDate.month;
				year = this.lastSession.newDate.year;

				// const array2 = this.lastSession.startTime.split(":");
				// hour = array2[0];
				// minute = array2[1];
				hour =
					this.lastSession.newStartTime.hour < 10
						? `0${this.lastSession.newStartTime.hour}`
						: this.lastSession.newStartTime.hour;
				minute =
					this.lastSession.newStartTime.minute < 10
						? `0${this.lastSession.newStartTime.minute}`
						: this.lastSession.newStartTime.minute;

				const lastTime = this.luxon.createTimeStamp(
					this.luxon.createDate(`${year}`, `${month}`, `${day}`, `${hour}`, `${minute}`, seconds)
				);

				// carries 100 more sessions
				this.dbSchedule.getNextPageSessionsGlobalVision(this.moduleId, this.lastSession, (data) => {
					this.lastSession = null;
					let list = [];

					if (data["sessions"].length >= 1) {
						this.lastSession = data["nextPage"];
						list = [...data["sessions"]];
					}

					const sessionIds = [...this.sessions].map((s) => s.uid);
					// treatment of sessions
					for (let session of list) {
						if (!sessionIds.includes(session.uid)) {
							session = this.setTheSession(session);
							this.sessions.push(session);
							if (this.sessions.length == this.allSessionsLength) {
								event.target.disabled = true;
							}
						}
					}

					this.allSessionDates = Array.from(new Set([...this.sessionsAll].map((item) => item.dateFormated)));
					// check if you still have sessions to search
					if (this.lastSession) {
						// this.virtualScroll.checkEnd();
						event.target.complete();
					} else {
						event.target.disabled = true;
					}
				});
			} else {
				event.target.disabled = true;
			}
		}
		// If the array that stores all module sessions has not been loaded.
		else if (this.allSessionsLength == 0) {
			// this.virtualScroll.checkEnd();
			event.target.complete();
		} else {
			event.target.disabled = true;
		}
	}

	//limited access by groups
	// getLimitedAccessByGroupsVision() {
	// 	this.loader = true;

	// 	this.viewHour = true;
	// 	this.viewTrack = false;
	// 	this.viewGroup = false;
	// 	this.searchBtn = true;

	// 	// get the first 100 sessions of the module.
	// 	this.dbSchedule.getFirstPageSessionsLimitedAccessByGroups(this.moduleId).subscribe((data) => {
	// 		let nextPage = null;
	// 		let list = [];
	// 		this.sessions = [];

	// 		if (data) {
	// 			nextPage = data["nextPage"];
	// 			list = [...data["sessions"]];
	// 		}

	// 		// takes the start time of the last session loaded.
	// 		if (nextPage) {
	// 			this.lastSession = nextPage;
	// 		}

	// 		// treatment of sessions
	// 		for (let session of list) {
	// 			session = this.setTheSession(session);
	// 		}

	// 		this.sessions = list;
	// 		this.allSessionDates = Array.from(new Set([...this.sessions].map((item) => item.dateFormated)));
	// 		this.loader = false;
	// 	});

	// 	// counts the total sessions you have in the module. (global vision)
	// 	this.dbSchedule.countsSessionsInTheModule(this.moduleId, (total) => {
	// 		this.allSessionsLength = total;
	// 	});

	// 	// load all module sessions and all different dates. Using the api
	// 	this.dbSchedule.getAllSessionsLimitedAccessByGroup(this.moduleId).subscribe((sessions) => {
	// 		this.sessionsAll = [];
	// 		this.dates = [];

	// 		[...sessions].forEach((session) => {
	// 			this.sessionsAll.push(this.setTheSession(session));
	// 			// pick up all different dates of sessions
	// 			const index = this.dates.indexOf(session.date.toString());

	// 			if (index === -1) {
	// 				this.dates.push(session.newDate);
	// 			}
	// 		});

	// 		this.dates = [...this.dates].filter(
	// 			(date, index, self) =>
	// 				index ===
	// 				self.findIndex(
	// 					(x) =>
	// 						x.day === date.day &&
	// 						x.hour === date.hour &&
	// 						x.millisecond === date.millisecond &&
	// 						x.minute === date.minute &&
	// 						x.month === date.month &&
	// 						x.second === date.second &&
	// 						x.year === date.year &&
	// 						x.zone === date.zone
	// 				)
	// 		);

	// 		// Push sessions on store
	// 		this.pushScheduleSessionsOnStore(this.sessionsAll);

	// 		if (this.dates) this.allowFilterByDate = true;
	// 	});
	// }

	// loads more sessions when the infinite scroll is triggered (limited access by groups )
	moreSessionsLimitedAccessByGroups(event) {
		if (this.sessions.length < this.allSessionsLength) {
			if (this.lastSession) {
				// convert a date plus the start time of the last session to timastamp for the search of the bank.
				let year = "2019";
				let month = "12";
				let day = "01";
				let hour = "00";
				let minute = "00";
				let seconds = "00";

				// const array1 = this.lastSession.date.split("/");
				// day = array1[0];
				// month = array1[1];
				// year = array1[2];
				day =
					this.lastSession.newDate.day < 10
						? `0${this.lastSession.newDate.day}`
						: this.lastSession.newDate.day;
				month =
					this.lastSession.newDate.month < 10
						? `0${this.lastSession.newDate.month}`
						: this.lastSession.newDate.month;
				year = this.lastSession.newDate.year;

				// const array2 = this.lastSession.startTime.split(":");
				// hour = array2[0];
				// minute = array2[1];
				hour =
					this.lastSession.newStartTime.hour < 10
						? `0${this.lastSession.newStartTime.hour}`
						: this.lastSession.newStartTime.hour;
				minute =
					this.lastSession.newStartTime.minute < 10
						? `0${this.lastSession.newStartTime.minute}`
						: this.lastSession.newStartTime.minute;

				const lastTime = this.luxon.createTimeStamp(
					this.luxon.createDate(year, month, day, hour, minute, seconds)
				);

				// carries 100 more sessions
				this.dbSchedule.getNextPageSessionsLimitedAccessByGroups(this.moduleId, lastTime, (data) => {
					this.lastSession = null;
					let list = [];

					if (data) {
						this.lastSession = data["nextPage"];
						list = [...data["sessions"]];
					}

					const sessionIds = [...this.sessions].map((s) => s.uid);
					// treatment of sessions
					for (let session of list) {
						if (!sessionIds.includes(session.uid)) {
							session = this.setTheSession(session);
							this.sessions.push(session);
							if (this.sessions.length == this.allSessionsLength) {
								event.target.disabled = true;
							}
						}
					}

					this.allSessionDates = Array.from(new Set([...this.sessionsAll].map((item) => item.dateFormated)));

					// check if you still have sessions to search
					if (this.lastSession) {
						// this.virtualScroll.checkEnd();
						event.target.complete();
					} else {
						event.target.disabled = true;
					}
				});
			} else {
				event.target.disabled = true;
			}
		}
		// If the array that stores all module sessions has not been loaded.
		else if (this.allSessionsLength == 0) {
			// this.virtualScroll.checkEnd();
			event.target.complete();
		} else {
			event.target.disabled = true;
		}
	}

	/**
	 * Push schedule sessions on store
	 * @param sessions
	 */
	pushScheduleSessionsOnStore(sessions: any[]) {
		this.store.dispatch(new GetScheduleSessions(sessions));
	}

	displayDate(date: string) {
		return new Date(date).toLocaleDateString(this.dt.deviceLocale, {
			month: "short",
			day: "2-digit",
			timeZone: this.dt.deviceTimeZone
		});
	}

	selectMonth(month: number) {
		let finalMonth;
		switch (month) {
			case 1:
				finalMonth = this.translateService.instant("global.texts.january");
				break;
			case 2:
				finalMonth = this.translateService.instant("global.texts.february");
				break;
			case 3:
				finalMonth = this.translateService.instant("global.texts.march");
				break;
			case 4:
				finalMonth = this.translateService.instant("global.texts.april");
				break;
			case 5:
				finalMonth = this.translateService.instant("global.texts.may");
				break;
			case 6:
				finalMonth = this.translateService.instant("global.texts.june");
				break;
			case 7:
				finalMonth = this.translateService.instant("global.texts.july");
				break;
			case 8:
				finalMonth = this.translateService.instant("global.texts.august");
				break;
			case 9:
				finalMonth = this.translateService.instant("global.texts.september");
				break;
			case 10:
				finalMonth = this.translateService.instant("global.texts.october");
				break;
			case 11:
				finalMonth = this.translateService.instant("global.texts.november");
				break;
			case 12:
				finalMonth = this.translateService.instant("global.texts.december");
				break;
		}
		return finalMonth;
	}

	scrollToTop() {
		this.content.scrollToTop(500);
	}

	scrollPillsLeft() {
		if (this.datePillStrip?.nativeElement) {
			this.datePillStrip.nativeElement.scrollBy({ left: -200, behavior: 'smooth' });
		}
	}

	scrollPillsRight() {
		if (this.datePillStrip?.nativeElement) {
			this.datePillStrip.nativeElement.scrollBy({ left: 200, behavior: 'smooth' });
		}
	}

	ionViewDidEnter() {
		this.activeDate = "all";
	}

	getSpeakers(speakersObj) {
		const listKeys = Object.keys(speakersObj);

		return [...listKeys]
			.map((x) => speakersObj[x])
			.sort((a, b) =>
				a.name.toLowerCase() > b.name.toLowerCase() ? 1 : a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 0
			);
	}

	colorMix(track: any): string {
		if (track.bgColor) return track.bgColor;
		if (track.txtColor) return track.txtColor + '18';
		return 'rgba(0,0,0,0.06)';
	}

	getPrimaryTrackColor(tracks: any[]): string {
		if (!tracks || tracks.length === 0) return 'transparent';
		return tracks[0].bgColor || tracks[0].txtColor || 'transparent';
	}

	private hasValidTime(value: any): boolean {
		return typeof value === 'string' && value.length > 0 && !isNaN(new Date(value).getTime());
	}

	private isToday(session: any): boolean {
		const now = new Date();
		const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
		return session.date && session.date.substring(0, 10) === today;
	}

	private getSessionDateTime(session: any, field: string): Date | null {
		const time = session[field];
		if (!time || time === '--:--') return null;
		const datePart = session.date.substring(0, 10);
		const [hours, minutes] = time.split(':');
		const d = new Date(
			+datePart.substring(0, 4),
			+datePart.substring(5, 7) - 1,
			+datePart.substring(8, 10),
			+hours,
			+minutes
		);
		return d;
	}

	isSessionNow(session: any): boolean {
		if (!this.isToday(session)) return false;
		const now = new Date(this.currentTime);
		const start = this.getSessionDateTime(session, 'startTime');
		const end = this.getSessionDateTime(session, 'endTime');
		if (!start || !end) return false;
		return now >= start && now <= end;
	}

	isSessionPast(session: any): boolean {
		if (!this.isToday(session)) return false;
		const now = new Date(this.currentTime);
		const end = this.getSessionDateTime(session, 'endTime');
		if (!end) return false;
		return now > end;
	}

}
